import StructClient from './StructClient';
import { DataStructure } from '../../domain/structure/DataStructureDomains';
import HttpClient from '../../gateway/HttpClient';
import HttpMethod from '../../constant/HttpMethod';
import { DataStructureMethods } from '../../constant/MethodNames';
import { notUndefined } from '../../util/Assert';
import { query } from '@trlogic/client-js';

class NestStructClient implements StructClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'http client can not be undefined');
    this.httpClient = httpClient;
  }

  public remove(name: string): Promise<any> {
    return this.httpClient.execute(HttpMethod.DELETE, `${DataStructureMethods.REMOVE}?id=${name}`);
  }

  public save(struct: DataStructure): Promise<any> {
    const dto = { id: struct.name, object: struct };
    return this.httpClient.execute(HttpMethod.POST, DataStructureMethods.SAVE, dto);
  }

  public exist(name: string): Promise<boolean> {
    return this.httpClient.execute(HttpMethod.GET, `${DataStructureMethods.EXIST}/${name}`);
  }

  public getById(id: string): Promise<DataStructure> {
    return this.httpClient.execute(HttpMethod.GET, `${DataStructureMethods.GET_BY_ID}`, undefined, { id });
  }

  public getByIds(ids: string[]): Promise<DataStructure[]> {
    return this.httpClient.execute(HttpMethod.GET, `${DataStructureMethods.GET_BY_IDS}`, undefined, { ids: JSON.stringify(ids) });
  }

  public count(_query: query.SelectQuery): Promise<number> {
    return this.httpClient.execute(HttpMethod.POST, DataStructureMethods.COUNT, _query);
  }

  public getAll(): Promise<DataStructure[]> {
    return this.httpClient.execute(HttpMethod.GET, DataStructureMethods.GET_ALL);
  }
}

export default NestStructClient;
